export default class NavigateEvent {
    constructor(type, screenType, screen, autoCenter, priority, needsOverlay, openUnderCurrent, animationType, animationOptions) {
        this.type = type;
        this.screenType = screenType;
        this.screen = screen;
        this.autocenter = autoCenter;
        this.priority = priority;
        this.needsOverlay = needsOverlay;
        this.openUnderCurrent = openUnderCurrent;
        this.animationType = animationType;
        this.animationOptions = animationOptions;
    }
}
NavigateEvent.OPEN_SCREEN_REQUEST = "openScreenRequest";
NavigateEvent.GOTO_SCREEN_REQUEST = "screenRequest";
NavigateEvent.CLOSE_SCREEN_REQUEST = "closeScreenRequest";
NavigateEvent.POP_UP_REQUEST = "popUpRequest";
NavigateEvent.CLOSE_POP_UP_REQUEST = "closePopUpRequest";